import { ApplicationConfig, inject } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { InterceptorService } from './Services/Utils/interceptor.service';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { textosPaginacion } from './Services/Utils/paginator-custom.service';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations()
    , provideRouter(routes)
    , provideHttpClient(
        withFetch(),
        withInterceptors([
        (req, next) => inject(InterceptorService).intercept(req, { handle: next })
    ]))
    , {
      provide: MatPaginatorIntl
      , useFactory: textosPaginacion
    }
    , {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS
      , useValue: { appearance: 'outline' }
    }
  ]
};